const home = {
  heroAlt: "محترفون يراجعون المخططات في مشروع ترميم",
  galleryAlt: "قطاع البناء والترميم",
  install: {
    iosSub: "حمّله من",
    androidSub: "متوفر على",
    iosTitle: "التثبيت على iPhone/iPad",
    iosDesc: "افتح هذه الصفحة في Safari، واضغط على مشاركة ثم «إضافة إلى الشاشة الرئيسية».",
    androidTitle: "تثبيت التطبيق",
    androidDesc: "افتح قائمة المتصفح واختر «تثبيت التطبيق» / «إضافة إلى الشاشة الرئيسية».",
  },
  apps: {
    nuvliTitle: "تطبيق NuvliPro للجوال",
    nuvliDesc: "عروض الأسعار والفواتير والمشاريع والمصروفات ومتابعة ساعات العمل على جوالك.",
    nuvliInstall: "حمّل NuvliPro",
    nuvliNote: "تثبيت مباشر (PWA) · يعمل على Android وiPhone دون أن يشغل مساحة.",
    workerTitle: "تطبيق تسجيل الحضور بنظام GPS",
    workerDesc: "للموظفين: تسجيل الدخول والخروج بنظام GPS والدخول برمز وصول.",
    workerInstall: "حمّل تطبيق الحضور GPS",
    workerNote: "للعمال · بعد التثبيت افتح التطبيق وسجّل الدخول برمز الوصول الخاص بك.",
    workerCta: "افتح تطبيق الموظف",
    qrTitle: "تسجيل الحضور بنظام GPS",
    qrSubtitle: "تسجيل حضور سهل وآمن لفريقك",
    qrText: "حمّله مجانًا من موقعنا",
    qrInstall: "التثبيت على الجوال",
    qrAvailable: "متاح لأجهزة Android وiPhone",
  },
  login: {
    title: "تسجيل الدخول", email: "البريد الإلكتروني", password: "كلمة المرور", emailPh: "you@email.com", submit: "دخول",
    forgot: "هل نسيت كلمة المرور؟", register: "سجّل مجانًا", welcome: "مرحبًا بك", error: "تعذّر تسجيل الدخول",
  },
  features: {
    badge: "الميزات",
    title: "كل ما تحتاجه لإدارة عملك",
    items: [
      { t: "الفوترة", d: "فواتير بترقيم تلقائي وضريبة القيمة المضافة والاستقطاعات والحالات وتنزيل PDF احترافي." },
      { t: "عروض الأسعار", d: "عروض أسعار مقسمة إلى فصول وبنود مفصلة؛ حوّلها إلى فاتورة بنقرة واحدة." },
      { t: "مراقبة المصروفات", d: "سجّل المواد والعمالة والتوريدات؛ وراقب الإنفاق حسب المشروع والفئة." },
      { t: "الدفعات الجزئية", d: "سجّل الدفعات المقدمة وتابع الرصيد المستحق وأرسل الإيصالات تلقائيًا." },
      { t: "التقارير الفصلية", d: "ضريبة القيمة المضافة وضريبة الدخل لكل ربع سنة، جاهزة لمحاسبك وقابلة للتصدير إلى PDF وExcel." },
      { t: "إدارة العملاء", d: "ملف كامل لكل عميل وسجل المستندات واكتشاف التأخر في السداد." },
    ],
  },
  pricing: {
    badge: "الخطط والأسعار",
    title: "اختر الخطة الأنسب لعملك",
    subtitle: "ابدأ مجانًا ودون تاريخ انتهاء. رقِّ خطتك متى احتجت إلى المزيد: بلا التزام، ويمكنك الإلغاء متى شئت.",
    freeCta: "أنشئ حسابًا مجانيًا",
    labels: { gratuito: "الخطة المجانية", trimestral: "الخطة الفصلية", anual: "الخطة السنوية" },
    perMonth: "{{amount}} / شهريًا",
    approx: "≈ {{amount}} / شهريًا",
    periodo: { gratuito: "دون تاريخ انتهاء", trimestral: "{{total}} كل 3 أشهر", anual: "{{total}} سنويًا" },
    nota: { gratuito: "للبدء دون دفع", trimestral: "بلا حدود، بالدفع كل 3 أشهر", anual: "دفعة واحدة في السنة" },
    badges: { trimestral: "الأكثر طلبًا" },
    save: "توفّر {{amount}} سنويًا",
    features: {
      gratuito: ["حتى 8 عملاء", "حتى 8 عروض أسعار", "الفوترة والدفعات الجزئية لعملائك الثمانية", "المصروفات والتقارير الفصلية: آخر فصلين", "مشروعا بناء", "تسجيل الحضور لعدد غير محدود من العمال"],
      trimestral: ["عملاء وعروض أسعار ومشاريع بلا حدود", "السجل الكامل للمصروفات والفصول", "الذكاء الاصطناعي وVeriFactu والمطابقة البنكية", "تذكيرات عبر البريد الإلكتروني وWhatsApp", "تصدير لمحاسبك"],
      anual: ["كل ما في الخطة الفصلية", "تخصيص المستندات والشعار", "تنبيهات تلقائية مجدولة", "دعم ذو أولوية"],
    },
    payCard: "ادفع بالبطاقة",
    payNote: "البطاقة: تجديد تلقائي، يمكنك الإلغاء في أي وقت",
    footnote: "الأسعار لا تشمل ضريبة القيمة المضافة · الدفع بالبطاقة · دفع آمن عبر Stripe",
    approxNote: "قيمة تقريبية بعملة {{currency}} حسب سعر الصرف اليوم. يظهر المبلغ الدقيق في صفحة الدفع.",
    payError: "تعذّر بدء عملية الدفع",
  },
  trust: {
    title: "محترفون يثقون بالفعل في NuvliPro",
    subtitle: "آراء حقيقية من شركات في قطاع البناء والترميم.",
    testimonials: [
      { cargo: "المدير العام", empresa: "Constructora MendozaBuild S.A.", texto: "عملنا أكثر من عشر سنوات على Excel وأنظمة لا تتواصل فيما بينها. مع NuvliPro جمعنا كل معلومات مشاريعنا الثمانية وخفّضنا وقت الإدارة بنسبة 60%. أصبحت تقارير الربحية لكل مشروع دقيقة، وأتخذ قراراتي بناءً على بيانات حقيقية لا على الحدس." },
      { cargo: "مديرة المشاريع", empresa: "Grupo Constructor Rojas & Asociados", texto: "انتقلنا من 3 إلى 12 مشروعًا نشطًا وانهار نظامنا اليدوي. مع NuvliPro نمونا دون مضاعفة عدد الموظفين الإداريين: تتبّع كامل لكل مادة، ومتابعة المقاولين من الباطن في الوقت الفعلي، ووثائق ختامية أقل بنسبة 75%. يتلقى عملاؤنا تقارير تبعث على الثقة." },
      { cargo: "مالك مستقل", empresa: "18 عامًا في القطاع", texto: "أصبحت أعمالي أكثر تعقيدًا وأقل ربحية، وكانت التكاليف تتسرب دون أن أعرف أين. مع NuvliPro اكتشفت مواضع التسرب المالي، ووحّدت الموردين، وخفّضت التكاليف العامة بنسبة 22% دون التضحية بالجودة. الآن أُعدّ عروض أسعار أكثر تفصيلًا في وقت أقل وأفوز بمشاريع أكثر." },
    ],
    seals: [
      { t: "متوافق مع GDPR", d: "بيانات محمية" },
      { t: "تشفير SSL", d: "اتصال آمن" },
      { t: "مدفوعات عبر Stripe", d: "تحصيل آمن" },
      { t: "دعم باللغة الإسبانية", d: "متى احتجت إليه" },
    ],
  },
  demo: {
    badge: "فيديو توضيحي",
    title: "تعرّف على NuvliPro في دقيقتين",
    subtitle: "شاهد كيفية إنشاء عرض سعر وتحويله إلى فاتورة ومتابعة الدفعات والمصروفات.",
    unsupported: "متصفحك لا يدعم تشغيل الفيديو.",
    soon: "الفيديو التوضيحي قريبًا",
  },
  faq: {
    badge: "الأسئلة الشائعة",
    title: "نجيب عن أسئلتك",
    items: [
      { q: "هل أحتاج إلى معرفة بالمحاسبة لاستخدام NuvliPro؟", a: "لا. صُمّم NuvliPro للعاملين لحسابهم الخاص والشركات الصغيرة: تنشئ عروض الأسعار والفواتير بملء حقول واضحة، ويحسب التطبيق تلقائيًا ضريبة القيمة المضافة والاستقطاعات والإجماليات." },
      { q: "هل يمكنني تجربته مجانًا؟", a: "نعم. الخطة المجانية لا تنتهي ولا تتطلب بطاقة: حتى 8 عملاء و8 عروض أسعار و8 فواتير ومشروع بناء نشط واحد. وعندما تحتاج إلى المزيد، رقِّ إلى خطة مدفوعة." },
      { q: "هل بيانات عملائي آمنة؟", a: "نعم. نشفّر الاتصال (SSL)، ونلتزم باللائحة العامة لحماية البيانات (GDPR)، وتُعالَج المدفوعات بأمان عبر Stripe. لا نشارك بياناتك أبدًا." },
      { q: "هل يمكنني تخصيص فواتيري وعروض أسعاري بشعاري؟", a: "نعم. من منطقتك الشخصية يمكنك رفع شعار شركتك واختيار تصميم المستند بما يعكس علامتك التجارية." },
      { q: "هل يساعد NuvliPro في المتابعة الفصلية للضرائب؟", a: "نعم. ينشئ تلقائيًا ملخص ضريبة القيمة المضافة المحصّلة/المدفوعة وضريبة الدخل لكل ربع سنة، قابلًا للتصدير إلى PDF وExcel لمحاسبك." },
      { q: "هل يمكنني الإلغاء متى أردت؟", a: "بالتأكيد. لا يوجد أي التزام: يمكنك تغيير خطتك أو إلغاؤها في أي وقت من حسابك." },
    ],
  },
  contact: {
    badge: "اتصل بنا",
    title: "هل نتحدث؟",
    subtitle: "أخبرنا بما تحتاجه وسنرد عليك في أقرب وقت ممكن. نحن هنا لمساعدتك على الاستفادة القصوى من NuvliPro.",
    support: "خدمة العملاء",
    supportNote: "الدعم باللغة الإسبانية · الرد خلال 24-48 ساعة",
    name: "الاسم", namePh: "اسمك", email: "البريد الإلكتروني", emailPh: "you@email.com",
    message: "الرسالة", messagePh: "كيف يمكننا مساعدتك؟", send: "إرسال الرسالة",
    sent: "تم إرسال الرسالة! سنرد عليك قريبًا.", error: "تعذّر إرسال الرسالة",
  },
  cta: {
    title: "عملك بالكامل في مكان واحد",
    items: ["العملاء", "عروض الأسعار", "الفوترة", "الدفعات الجزئية", "المصروفات", "التقارير الفصلية", "التأخر في السداد", "WhatsApp"],
    button: "أنشئ حسابي المجاني",
  },
  footer: "إدارة شاملة لمحترفي البناء والترميم",
};
export default home;
